<template>
  <StudioMultiSelect
    v-model="channelsSelected"
    :searchable="true"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label + ' Listening')"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ channelsSelected.length }} {{ filterMessage(channelsSelected) }}
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import channelModel from '@/mixins/channel-model';
import filtersModel from '@/mixins/filters-model';
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import { LISTENING_FILTER_EXCLUDED_CHANNELS } from '@/utils/channels';

export default {
  name: 'ChannelFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    channelModel,
    filtersModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isBigFour: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    dataType: {
      type: String,
      default: null,
    },
  },
  computed: {
    label() {
      return this.$t('components.filters.ChannelFilter.label');
    },
    placeholder() {
      return this.$t('components.filters.ChannelFilter.placeholder');
    },
    channelsSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newChannels = newValue;

        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        if (newValue && newValue.length && typeof (newValue[0]) === 'object') {
          newChannels = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newChannels,
        });
      },
    },
    selectItemsValue() {
      return this.selectItems.map(v => v.value);
    },
    selectItems() {
      const channelToSelectObject = (channel) => {
        const channelObj = this.getChannelObj(channel);
        return {
          text: channelObj.name,
          value: channel,
        };
      };

      const channelsToSelect = this.isBigFour ? this.fourBigChannels : this.channels;
      const isListeningFilter = [DATA_TYPE.LISTENING, DATA_TYPE.SAC_LISTENING].includes(this.dataType);

      return channelsToSelect
        .filter(channel => !isListeningFilter || !LISTENING_FILTER_EXCLUDED_CHANNELS.includes(channel))
        .map(channelToSelectObject);
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
